(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinematic-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'cinematic-hero-text-motion-v2';
  if (!window.customElements || customElements.get(tag)) return;

  class CinematicHeroTextMotion extends HTMLElement {
    connectedCallback() {
      // Runs again automatically when Shopify replaces this section in the editor.
      this.frame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      this.root = this.closest('.cinematic-hero-section');
      if (!this.root || !Element.prototype.animate) return;
      this.animations = [];
      this.words = [];
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = () => {
        this.clearEffects();
        if (!this.motion.matches) this.prepare();
      };
      this.motion.addEventListener('change', this.onMotion);
      this.onFocus = () => this.reveal();
      this.root.addEventListener('focusin', this.onFocus);
      this.editorSection = this.closest('.shopify-section') || this.root;
      this.onSelect = () => { this.selected = true; this.reveal(); };
      this.onDeselect = () => { this.selected = false; };
      this.editorSection.addEventListener('shopify:section:select', this.onSelect);
      this.editorSection.addEventListener('shopify:section:deselect', this.onDeselect);
      if (!this.motion.matches) this.prepare();
    }

    splitWords(element, characters = false) {
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          return node.nodeValue.trim() && !node.parentElement.closest('script, style, svg')
            ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
      });
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      const words = [];
      const segmenter = window.Intl && Intl.Segmenter
        ? new Intl.Segmenter(document.documentElement.lang || undefined, { granularity: 'grapheme' })
        : null;
      let wordBreak = false;
      nodes.forEach(node => {
        const fragment = document.createDocumentFragment();
        node.nodeValue.split(/(\s+)/u).forEach(part => {
          if (!part) return;
          if (/^\s+$/u.test(part)) {
            fragment.appendChild(document.createTextNode(part));
            wordBreak = true;
          } else {
            const units = characters
              ? (segmenter ? Array.from(segmenter.segment(part), item => item.segment) : Array.from(part))
              : [part];
            units.forEach((unit, index) => {
              const span = document.createElement('span');
              // Reserve every character from the start: typing never moves the layout.
              span.textContent = unit;
              span.dataset.wordStart = String(index === 0 && wordBreak);
              fragment.appendChild(span);
              words.push(span);
              this.words.push(span);
            });
            wordBreak = false;
          }
        });
        node.replaceWith(fragment);
      });
      return words;
    }

    prepare() {
      try {
        const duration = Math.max(300, Math.min(1800, Number(this.dataset.duration) || 900));
        const delay = Math.max(0, Math.min(2000, Number(this.dataset.delay) || 0));
        const stagger = Math.max(20, Math.min(200, Number(this.dataset.stagger) || 100));
        const effects = {
          fade: [{ opacity: 0 }, { opacity: 1 }],
          slide_up: [{ opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }],
          slide_left: [{ opacity: 0, transform: 'translateX(-30px)' }, { opacity: 1, transform: 'translateX(0)' }],
          blur: [{ opacity: 0, filter: 'blur(8px)' }, { opacity: 1, filter: 'blur(0px)' }],
          wipe: [{ clipPath: 'inset(0 100% 0 0)' }, { clipPath: 'inset(0 0% 0 0)' }]
        };
        const letterSpeed = Math.max(20, Math.min(150, Number(this.dataset.letterSpeed) || 65));
        const wordPause = Math.max(0, Math.min(500, Number(this.dataset.wordPause) || 0));
        let nextGroupStart = delay;
        const groups = [
          [this.root.querySelector('.cinematic-hero__title'), this.dataset.heading, 0],
          [this.root.querySelector('.cinematic-hero__description'), this.dataset.description, 180]
        ];
        groups.forEach(([element, style, offset]) => {
          if (!element || style === 'none') return;
          const typing = style === 'typing';
          const split = typing || style === 'words' || style === 'writing';
          if (!split && !effects[style]) return;
          const targets = split ? this.splitWords(element, typing) : [element];
          // Keep long descriptions from taking excessively long to reveal.
          const spacing = Math.min(stagger, 3500 / Math.max(1, targets.length - 1));
          let typingTime = Math.max(delay + offset, nextGroupStart);
          targets.forEach((target, index) => {
            if (typing && index > 0) typingTime += letterSpeed + (target.dataset.wordStart === 'true' ? wordPause : 0);
            const animation = target.animate(split ? effects.fade : effects[style], {
              duration: (typing || style === 'writing') ? 1 : duration,
              delay: typing ? typingTime : delay + offset + (split ? index * spacing : 0),
              easing: (typing || style === 'writing') ? 'steps(1, end)' : 'cubic-bezier(0.22, 1, 0.36, 1)',
              fill: 'both'
            });
            animation.pause();
            animation.currentTime = 0;
            animation.onfinish = () => animation.cancel();
            this.animations.push(animation);
          });
          if (typing) nextGroupStart = typingTime + 350;
        });
        if (!this.animations.length) return;
        if (this.selected || this.root.contains(document.activeElement)) { this.reveal(); return; }
        this.played = false;
        this.inView = false;
        if (!('IntersectionObserver' in window)) { this.play(); return; }
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (!this.inView && !this.selected &&
                  (!this.played || this.dataset.replay === 'true')) this.play();
              this.inView = true;
              if (this.dataset.replay !== 'true') this.observer.disconnect();
            } else {
              this.inView = false;
              // Leave content visible off-screen; restart only on re-entry.
              if (this.played) this.reveal();
            }
          });
        }, { threshold: 0 });
        this.observer.observe(this.root.querySelector('.cinematic-hero__content-inner') || this.root);
      } catch (error) {
        // Progressive enhancement: a failed animation never hides the content.
        this.clearEffects();
      }
    }

    play() {
      this.played = true;
      this.animations.forEach(animation => { animation.currentTime = 0; animation.play(); });
    }

    reveal() {
      (this.animations || []).forEach(animation => animation.cancel());
    }

    clearEffects() {
      if (this.observer) this.observer.disconnect();
      this.reveal();
      this.animations = [];
      const parents = new Set();
      (this.words || []).forEach(word => {
        if (word.parentNode) {
          parents.add(word.parentNode);
          word.replaceWith(document.createTextNode(word.textContent));
        }
      });
      parents.forEach(parent => parent.normalize());
      this.words = [];
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.clearEffects();
      if (this.motion) this.motion.removeEventListener('change', this.onMotion);
      if (this.root) this.root.removeEventListener('focusin', this.onFocus);
      if (this.editorSection) {
        this.editorSection.removeEventListener('shopify:section:select', this.onSelect);
        this.editorSection.removeEventListener('shopify:section:deselect', this.onDeselect);
      }
    }
  }
  customElements.define(tag, CinematicHeroTextMotion);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
